import { EventEmitter, Injectable } from '@angular/core';
import { Message } from '../components/message/message';
import { messages } from '../../../environments/environment';
import { MessageType } from '../components/message/message-type';

let instance: MessageService;

@Injectable()
export class MessageService {
  onMessage: EventEmitter<Message> = new EventEmitter();

  browserError: Error;
  serverError: Error;

  constructor() {
    if (instance) {
      return instance;
    } else {
      instance = this;
    }

    this.browserError = new Error();
    this.browserError.name = messages.BrowserError.Title;
    this.browserError.message = messages.BrowserError.Content;

    this.serverError = new Error();
    this.serverError.name = messages.ServerError.Title;
    this.serverError.message = messages.ServerError.Content;
  }

  showMessage(message: Message) {
    this.onMessage.emit(message);
  }

  showBrowserError() {
    this.showError(this.browserError);
  }

  showServerError() {
    this.showError(this.serverError);
  }

  showError(error: Error) {
    this.showMessage({
      type: MessageType.Error,
      title: error.name,
      content: error.message,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/message.service.ts